import unreleaseTripMessagesModule from "./unreleaseTripMessagesModule"
import unreleaseTripMessagesDialog from "./unreleaseTripMessageDialog.html"

unreleaseTripMessagesModule.service("unreleaseTripMessageDialog", [
        "$modal",
        function ($modal) {
            return function (message) {
                return $modal.open({
                    template: unreleaseTripMessagesDialog,
                    size: "xl",
                    backdrop: "static",
                    controller: ["$scope", function ($scope) {
                        $scope.message = message
                        $scope.tripTable = {
                            records: $scope.message.statusByTrip
                        }
                        $scope.erpMessagesTable = {
                            records: $scope.message.erpMessages
                        }
                        $scope.existsUser =  function (){
                            return !!$scope.message.processedByUser
                        }
                    }]
                })

            }
        }
    ])